import { render, staticRenderFns } from "./loginAs.vue?vue&type=template&id=726d68cb"
import script from "./loginAs.vue?vue&type=script&lang=js"
export * from "./loginAs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports